/* eslint-disable */

import axios from "axios";
// import { make } from "vuex-pathify";

const url = require("../../client_config/config").url;

const state = {
  unitList: [],
};

const getters = {
    // getUnitList: (state) => state.unitList,
};

const actions = {
    async getUnitList({ commit }, id) {
        try {
            const response = await axios.get(`${url}/units/unitlist/${id.toString()}`)
            commit("SET_UNIT_LIST", response.data);
            return response.data
        } catch (error) {
            console.error(error);
            return error;
        }
    },
};

const mutations = {
    // ...make.mutations(state),

    SET_UNIT_LIST(state, unitList) {
        state.unitList = unitList;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
